import { render, staticRenderFns } from "./BanChip.vue?vue&type=template&id=1d440224&"
import script from "./BanChip.vue?vue&type=script&lang=js&"
export * from "./BanChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports